/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */
    continue: 'ادامه',
    optional: 'اختیاری',
    instructions: 'دستورالعمل‌ها',
    no_results: 'بی نتیجه',
    click_to_confirm: 'برای تأیید کلیک کنید',
    caution: 'احتیاط',
    are_you_sure: 'مطمئن هستید؟',
    important: 'مهم',
    i_confirm: 'تأیید می‌کنم',

    /* Module special vocabulary */
    recipients: {
        menu: {
            index: 'گیرندگان',
            create: 'ایجاد گیرنده جدید',
            list: 'لیست گیرندگان',
            recipients: 'گیرندگان'
        },
        table_titles: {
            id: 'شناسه',
            name: "نام کامل گیرنده",
            description: 'توضیحات',
            phone: 'تلفن',
            address: "آدرس گیرنده",
            currency: 'ارز',
            account_number: 'شماره حساب',
            setting: 'ویرایش / حذف',
        },
        bank_accounts: {
            index: 'حساب‌های بانکی گیرنده',
            bank: 'بانک',
            type: 'روش پرداخت',
            info_label1: 'مقدار اولیه',
            info_label2: 'مقدار ثانویه',
            setting: 'حذف',
            edit_form: 'فرم ویرایش حساب بانکی گیرنده',
        },
        edit: 'ویرایش گیرنده',
        recipient_address_hint: "آدرس محل سکونت گیرنده",
        confirm_recipient_currency: 'ارز گیرنده را تأیید کنید',
        select_recipient_currency: 'ارز گیرنده را انتخاب کنید',
        notice1: 'شما <b>{currency}</b> را به عنوان ارز مقصد انتخاب کرده‌اید. اگر چنین نیست، لطفاً به گام نخست بازگردید و ارز را تغییر دهید.',
        details_for: 'مشخصات گیرنده‌ی {country}',
        tick_if_recipients_account_name_for: 'اگر گیرنده‌ی <b>{full_name}</b> ،<b>{outgoing_country}</b> است، این گزینه را انتخاب کنید.',
        full_name_of_account_holder: 'نام کامل صاحب حساب',
        ideally_in_the_language_of: 'ترجیحاً به زبان کشور',
        recipients_phone_number: 'شماره تماس گیرنده',
        a_nickname_to_identify_this_recipient_in_your_list: 'مشخصه‌ای برای نمایش این گیرنده در لیست گیرندگان',
        how_does_your_receiver_want: 'گیرنده به چه روشی {currency} را دریافت می‌کند؟',
        by_deleting_this_recipient_all_related_bank_accounts_will_be_deleted: 'با حذف این گیرنده، تمام حساب‌های بانکی او نیز حذف خواهد شد.',
        we_are_taking_you_to_the_recipients_page: 'جهت ویرایش مشخصات گیرنده وجه می‌بایست از مسیرثبت سفارش خارج و به بخش گیرندگان بروید.',
        once_you_are_done_with_recipients_you_ll_need_to_start: '',
        exchange_rate_and_payment_amounts_will_be_locked: 'نرخ ارز و مبالغ پرداخت برای سفارش شما قفل می شود. لطفاً موارد زیر را تایید کنید',
        i_confirm_i_will_be_paying_from_my_bank_account: 'تأیید می‌کنم که پرداخت را از حساب بانکی خود با نام {name} انجام خواهم داد.',
        i_confirm_i_m_able_to_make_the_payment_asap: 'تأیید می‌کنم که می‌توانم پرداخت را به محض دریافت شماره حساب انجام دهم.',
        edit_recipient: 'ویرایش گیرنده',
        go_to_recipients: 'انتقال به صفحه گیرندگان',
        payment_method: 'روش پرداخت',
        bank: 'بانک',
        bank_name: 'بانک',
        add_more_accounts_for: 'افزودن حساب‌های دیگر {name}',
        add_a_recipient: 'افزودن گیرنده',
        accounts: 'حساب‌ها',
        send_money: 'ارسال پول',
        add_an_account_for: 'افزدون حسابی برای {name}',
        i_d_like_to: 'انتخاب نوع ویرایش:',
        edit_this_recipient_s_details: 'ویرایش اطلاعات این گیرنده',
        eg_account_number_is_wrong: 'مثال: اصلاح شماره حساب نادرست',
        switch_to_another_saved_recipient: 'انتخاب گیرندگان دیگر موجود در لیست',
        create_a_whole_new_recipient_first: 'افزودن یک شماره حساب جدید',
        select_the_new_recipient: 'انتخاب گیرنده جدید',
        current_recipient: 'گیرنده کنونی',
        update_order_and_recipient: 'به‌روز رسانی گیرنده و سفارش',
        update_order_s_recipient: 'به‌روز رسانی گیرنده سفارش',
        oops_you_don_t_have_any_other_recipient_to_pick: 'شما گیرنده دیگری برای انتخاب ندارید.',
        edit_recipient_s_details: 'ویرایش اطلاعات گیرنده',
        recipient_bank: 'بانک گیرنده',
        recipient_name: 'نام گیرنده',
        recipient_info_was_updated_successfully: 'اطلاعات گیرنده با موفقیت ویرایش شد!'
    }
}
